var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabBarProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91168 10.0168C3.70805 10.0312 1.7673 14.1738 1.21002 17.12C1.10043 17.6993 1.56829 18.2064 2.15836 18.2048L15.1331 18.1688C15.69 18.1672 16.1388 17.711 16.0646 17.1587C15.6894 14.3674 13.9298 10.003 8.91168 10.0168Z",
    stroke: "#141124",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6344 4.43679C12.6406 6.50142 10.892 8.22715 8.6705 8.23451C6.44901 8.24188 4.6902 6.52778 4.68406 4.46315C4.67792 2.39852 6.4265 0.672788 8.64798 0.665422C10.8695 0.658056 12.6283 2.37215 12.6344 4.43679Z",
    stroke: "#141124",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabBarProfile);
export default __webpack_public_path__ + "static/media/TabBarProfile.4762583f2efcac6987646d1c9d805350.svg";
export { ForwardRef as ReactComponent };